var _circle, _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLoginEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6667,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 22.0118L29.5929 22.0118C28.5151 22.0118 27.6393 21.136 27.6393 20.0581C27.6393 18.9803 28.5151 18.1045 29.5929 18.1045L30.334 18.1045L30.334 12.3333L9.00065 12.3333L9.00065 27.7606L30.334 27.7606L30.334 22.0118ZM10.4828 13.8153L15.2659 13.8153L15.2659 15.7241L16.7481 15.7241L16.7481 13.8153L28.8744 13.8153L28.8744 16.712C27.3249 17.0488 26.1797 18.4187 26.1797 20.058C26.1797 21.6973 27.3249 23.0671 28.8744 23.404L28.8744 26.2784L16.7481 26.2784L16.7481 24.3696L15.2659 24.3696L15.2659 26.2784L10.4828 26.2784L10.4828 13.8153Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.748 17.1616L16.748 19.3399L15.2659 19.3399L15.2659 17.1616L16.748 17.1616Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.748 20.7766L16.748 22.9549L15.2659 22.9549L15.2659 20.7766L16.748 20.7766Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEvent);
export default __webpack_public_path__ + "static/media/login-event.b5aa1d2bbb6534f4dc36a961d6190d1f.svg";
export { ForwardRef as ReactComponent };